(function () {
  if (window.__ggInit) return;
  window.__ggInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function selectTab(tab) {
    var root = tab.closest('[data-gg-tabs]');
    root.querySelectorAll('[data-gg-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gg-tab]');
    if (tab) { selectTab(tab); return; }
    var arrow = e.target.closest('[data-gg-scroll]');
    if (arrow) {
      var rail = arrow.closest('[data-gg-railwrap]').querySelector('.gg-rail');
      var dir = parseInt(arrow.getAttribute('data-gg-scroll'), 10);
      rail.scrollBy({ left: dir * rail.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-gg-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[data-gg-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = tabs[(i + tabs.length) % tabs.length];
    next.focus(); selectTab(next); e.preventDefault();
  });
})();
